<!--
 * @Author: lx13417 lx13417@ly.com
 * @Date: 2023-02-23 14:06:47
 * @LastEditors: lx13417 lx13417@ly.com
 * @LastEditTime: 2023-08-07 13:58:22
 * @FilePath: \frontend-public-h5\src\views\preInstalls\tvoucher\index.vue
-->
<template>
  <div class="home">
    <div class="home-contain" v-if="!isErr">
      <tabList :tabList="tabList" @tabSelect="tabSelect(arguments)" @tabStatusSelect="tabStatusSelect(arguments)">
      </tabList>

      <div class="no-result" v-if="!currentList.length || currentList.length == 0">
        <tc-empty :type="'emptyOrder_TC'" style="width:auto;" :btnTxt="''" :tip="'去别的地方看看吧～'" :description="'暂无优惠券'"
          @btnClick="jumpUrl"></tc-empty>
      </div>
      <div class="redpackhome">
        <redpack v-for="(item, index) in currentList" :key="index" 
          :memberId="memberId" 
          :redpackObj="item" 
          :trackInfo="trackInfo" 
          :hwPreInstallRefid="hwPreInstallRefid">
        </redpack>
      </div>
      <div class="err-tips" v-if="currentList && currentList.length > 0">
        <span class="err-tips-icon">*</span>
        <span class="err-tips-text">只为您保留3个月的红包优惠券充值记录</span>
      </div>
      <div class="home-loading" v-if="isDoing">
        <img src="https://file.40017.cn/touchweixinqq/weixin/public/img/loading.svg" />
      </div>
      <pop :popShow="popShow" @onClose="onClose" @exchange="exchange($event)"></pop>
    </div>
    <netError v-else></netError>
    <!-- <div class="home-btn" v-if="!isErr && !(!currentList.length || currentList.length == 0)" @click="jumpUrl">去领红包
      <div class="home-btn-tip" v-if="bannerTip">{{ bannerTip }}</div>
    </div> -->
  </div>
</template>

<script>
import request from '@/utils/request';

import tabList from './child/tabList.vue';
import redpack from './child/redpack.vue';
import pop from './child/pop.vue';
import recommend from './child/recommend.vue';
import netError from '@/components/base/netError.vue';
import { Swipe, SwipeItem } from 'vant';
import { Empty } from 'tc-business';

export default {
  components: {
    tabList,
    redpack,
    pop,
    netError,
    recommend,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Empty.Component.name]: Empty.Component,
  },
  data() {
    return {
      hwPreInstallRefid: '',
      memberId: '',
      activeTag: 0,
      couponPlay: '1',
      bannerFlag: true,
      isErr: false,
      popShow: false,
      isDoing: false,
      recommends: [],
      currentList: [],
      tabList: [],
      bannerList: [],
      bannerTip: '',
      redpackObj: {
        projectId: 1,
        status: 0,
        label: 0,
        type: 0,
      },
      trackInfo: {
        refid: '0000',
        tab1: '全部',
        tab2: '全部',
      },
      rule: `券膨胀：可通过完成对应答题任务，将面额较小的卡券膨胀为面额较大的卡券，最高可膨胀99倍哦；
券回收：可通过完成对应助力任务，将可回收的卡券金额按比例随机提现为现金；
券合成：可通过完成对应浏览任务，将可合成的两张卡券合成为一张金额较大的卡券，卡券金额一定大于任一一张合成的卡券哦；
券变身：可通过完成对应订单任务，将卡券变为随机一张超级大额卡券。
`,
    };
  },
  props: {},
  watch: {},
  computed: {},
  async created() {
    this.$loading.show();
    document.querySelector('body').style.backgroundColor = '#F6F8FB';
    _multi_bridge_ready(() => {
      // this.getNodeBanner();
      _multi_bridge.getDeviceInfo().then((res) => {
        if (res && res.CBData) {
          this.deviceInfo = res.CBData;
          this.hwPreInstallRefid = res.CBData.refid;
          console.log('&&&& - ', this.hwPreInstallRefid);
          this.appVersionNumber = res.CBData.appVersionNumber;
          if (this.deviceInfo.appVersionType == 'iPhone') {
            this.clientType = 'ios';
          } else {
            this.clientType = this.deviceInfo.appVersionType;
          }
          if (this.deviceInfo) {
            _multi_bridge
              .getMemberInfo({
                cacheType: '1',
                requestPermission: '1',
              })
              .then((res) => {
                if (res && res.CBData) {
                  this.memberInfo = res.CBData.memberInfo;
                  if (this.memberInfo && this.memberInfo.memberId) {
                    this.memberId = this.memberInfo.memberId;
                    this.config();
                    this.countAppCard();
                    // this.getEmptyList();
                  } else {
                    _multi_bridge.login().then((res) => {
                      if (res && res.CBData) {
                        this.memberInfo = res.CBData.memberInfo;
                        if (this.memberInfo && this.memberInfo.memberId) {
                          window.location.reload();
                        } else {
                          _multi_bridge.navigateBack();
                        }
                      }
                    });
                  }
                }
              });
          }
        }
      });
    });

    // this.refid = this.$getURLParam('refid') || '0000';
    this.refid = '1948643492'; // 写死（PM 要求）
    this.trackInfo.refid = this.refid;

    this.activityCode = this.$getURLParam('activityCode') || '';
    this.strategyCode = this.$getURLParam('strategyCode') || '';
  },
  mounted() {
    // webapp 激活，失活通知
    if (!window._tc_web_bar) {
      window._tc_web_bar = {};
    }
    window._tc_web_bar.tag_isStop = (data) => {
      if (data.isStop == 'false' && this.activeTag > 0) {
        // 激活状态
        this.countAppCard();
      } else {
      }
      ++this.activeTag;
    };
  },
  methods: {
    getNodeBanner() {
      request({
        url: `${process.env.VUE_APP_BASE_URL}/activityplatform/api/activityCenter/getActivityConfig`,
        method: 'post',
        data: {
          bizPage: 15,
          business: 2,
          plat: 433,
          position: [38],
        },
      })
        .then((res) => {
          if (res && res.code == 'ok' && res.data) {
            const { list, show } = res.data['youhuiquanliebiaoye-guanggaowei'];
            const bannerTip = res.data['youhuiquanliebiaoye-tiaozhuananniuwenan'];
            if (show == 1) {
              // banner 图
              this.bannerList = list;
            }
            if (bannerTip && bannerTip.show == 1) {
              this.bannerTip = bannerTip.list[0].ButtonCopy;
            }
          }
        })
        .catch((err) => { });
    },

    // 卡券数量查询
    countAppCard() {
      request({
        url: `${process.env.VUE_APP_BASE_URL}/coupon/userCard/countAppCardMini`,
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          platTag: 'tcapp',
          deviceId: this.deviceInfo.deviceId,
          secureToken: this.memberInfo.memberIdNew,
          versionNum: this.appVersionNumber,
        },
        data: {
          memberId: this.memberInfo.memberId,
          clientType: this.clientType,
          versionNum: this.appVersionNumber,
        },
      })
        .then((res) => {
          if (res && res.code == 0) {
            this.tabList = [];
            let obj = res.data.userCardCount || {};
            this.couponPlay = res.data.couponPlay || '1';

            let sortMap = {
              // allCount: 0,
              trainCount: 1,
              airCount: 2,
              carCount: 3,
              // shipCount: 4,
              sceneryCount: 5,
              busCount: 6,
              hotelCount: 7,
              vacation: 8
              // restaurantCount: 8,
              // otherCount: 9,
              // goldCount: 10,
              // commonCount: 11,
            };
            for (let key in obj) {
              let id = sortMap[key];
              if (id || id == 0) {
                this.tabList.push({
                  id: id,
                  tabName: key,
                  tabNum: obj[key],
                });
              }
            }
            this.tabList.sort((a, b) => {
              return a.id > b.id;
            });
            this.getAppCardList();
          } else {
            this.isErr = true;
          }
        })
        .catch((err) => {
          this.isErr = true;
          this.$loading.hide();
          console.log('countAppCard err', err);
        });
    },

    // 卡券列表查询
    getAppCardList(cb) {
      this.isDoing = true;

      request({
        url: `${process.env.VUE_APP_BASE_URL}/coupon/userCard/appCouponListMini`,
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          platTag: 'tcapp',
          deviceId: this.deviceInfo.deviceId,
          secureToken: this.memberInfo.memberIdNew,
          versionNum: this.appVersionNumber,
        },
        data: {
          memberId: this.memberInfo.memberId,
          clientType: this.clientType,
          projectId: this.redpackObj.projectId,
          status: this.redpackObj.status,
          label: this.redpackObj.label,
          type: this.redpackObj.type,
          versionNum: this.appVersionNumber,
        },
      })
        .then((res) => {
          this.$loading.hide();
          if (res && res.code == 0) {
            if (res.data && Array.isArray(res.data)) {
              this.currentList = res.data.map((item) => {
                item.isRule = false;
                return item;
              });
              this.bannerFlag = this.currentList && this.currentList.length > 0;
            } else {
              this.currentList = [];
              this.bannerFlag = false;
            }
          } else {
            this.isErr = true;
          }
          this.isDoing = false;

          cb && cb();
        })
        .catch((err) => {
          this.$loading.hide();
          this.isErr = true;
          console.log('getAppCardList err', err);
        });
    },

    // 无数据空态页拉取领取中心接口数据
    getEmptyList() {
      //FIXME: MOCK
      // const result = require("./__mock__/empty.json")
      // this.recommends = result.data;
      // return

      request({
        url: `${process.env.VUE_APP_BASE_URL}/coupon/tab/miniList`,
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          platTag: 'tcapp',
          deviceId: this.deviceInfo.deviceId,
          secureToken: this.memberInfo.memberIdNew,
          versionNum: this.appVersionNumber,
        },
        data: {
          activityCode: this.activityCode || `${process.env.VUE_APP_VOUCHER_COUPON_ACTIVITYCODE}`,
          strategyCode: this.strategyCode || `${process.env.VUE_APP_VOUCHER_COUPON_STRATEGYCODE}`
        },
      })
        .then((result) => {
          if (result && result.code == 0) {
            this.recommends = result.data;
          }
        })
        .catch((err) => {

        });
    },

    // 兑换
    exchange(couponNum) {
      this.$loading.show({ type: 'part' });
      request({
        url: `${process.env.VUE_APP_BASE_URL}/coupon/userCard/exchangeAppCard`,
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          platTag: 'tcapp',
          deviceId: this.deviceInfo.deviceId,
          secureToken: this.memberInfo.memberIdNew,
          versionNum: this.appVersionNumber,
        },
        data: {
          memberId: this.memberInfo.memberId,
          couponCode: couponNum,
          versionNum: this.appVersionNumber,
        },
      })
        .then((res) => {
          this.$loading.hide();
          if (res && res.code == 0) {
            this.countAppCard();
            // this.getAppCardList();
            // 兑换成功
            this.$vToast('兑换成功~');
            this.onClose();
            this.track('我的优惠券兑换点击', `{"channel":"领券中心","scene":"公共","兑换码":"${couponNum}","兑换按钮":"成功",“toast”:"[${res.msg}]","refid":"${this.refid}"}`, 'coupon_myexchange_click');
          } else if (res && res.code == 1000) {
            // 风控
            this.$vToast('活动太火爆了～');
            this.onClose();
          } else {
            // 兑换失败
            this.$vToast(res.msg || '兑换失败');
            this.track('我的优惠券兑换点击', `{"channel":"领券中心","scene":"公共","兑换码":"${couponNum}","兑换按钮":"失败",“toast”:"[${res.msg}]","refid":"${this.refid}"}`, 'coupon_myexchange_click');
          }
        })
        .catch((err) => {
          console.log('countAppCard err', err);
          this.$loading.hide();
          if (err.message.includes('timeout')) {
            this.$vToast('您的优惠券正在赶来的路上');
          } else {
            this.$vToast('兑换失败');
          }
        });
    },

    tabSelect(arg) {
      this.$nextTick(() => {
        window.scrollTo(0, 0);
      });
      this.$set(this.trackInfo, 'tab1', arg[2]);
      let arr = Object.values(arg);
      this.redpackObj.projectId = arr[0];
      this.redpackObj.type = arr[1];
      this.getAppCardList(() => {
        this.emptyTrackShow();
      });
    },

    tabStatusSelect(arg) {
      this.$nextTick(() => {
        window.scrollTo(0, 0);
      });
      this.$set(this.trackInfo, 'tab2', arg[3]);
      if (arg[3] == '可回收') {
        this.track('优惠券列表tab点击', `{"channel":"红包优惠券","refid":"${this.refid}","tab":"${arg[3]}"}`, 'yhqlb_tab_click', 'cvg2021_apppublic_recycling');
        if (this.currentList.length > 0) {
          this.track('优惠券列表tab点击', `{"channel":"可回收页曝光","refid":"${this.refid}","name":"${this.currentList.length}张${this.trackInfo.tab1}"}`, 'yhqlb_khs_show', 'cvg2021_apppublic_recycling');
        }
      }
      let arr = Object.values(arg);
      this.redpackObj.projectId = arr[0];
      this.redpackObj.status = arr[1];
      this.redpackObj.label = arr[2];
      this.getAppCardList(() => {
        this.emptyTrackShow();
      });
    },

    // 空态页曝光埋点
    emptyTrackShow() {
      if ((this.currentList && this.currentList.length == 0) && (this.recommends && this.recommends.length > 0)) {
        this.track('空态页曝光', `{"channel":"红包优惠券","refid":"${this.refid}","name":"${this.trackInfo.tab1}"}`, 'yhqlb_kt_show', 'cvg2021_apppublic_recycling');
      }
    },
    recommend(item) {
      this.jumpUrl("recomm", item)
    },
    jumpUrl(from, obj) {
      if (from == 'recomm') {
        this.track('空态页点击', `{"channel":"红包优惠券","refid":"${this.refid}","name":"${obj.amount}元${this.trackInfo.tab1}","center_type":"去领券按钮"}`, 'yhqlb_kt_show', 'cvg2021_apppublic_recycling');
      } else {
        this.track('我的优惠券-领券中心点击', `{"channel":"领券中心","scene":"公共","refid":"${this.refid}"}`, 'coupon_myobtain_click');
      }
      let url = `https://m.17u.cn/couponstore/index?wvc6=1&tcwvclogin&refid=${this.refid}`;
      _multi_bridge.navigateTo({ url: url });
    },
    bannerClose() {
      this.bannerFlag = false;
    },
    bannerClick(item) {
      if (item && item.JumpLink) {
        this.openNewUrl(item.JumpLink);
      }
    },
    onClose() {
      this.popShow = false;
    },
    see() {
      this.track('我的优惠券点击', `{"channel":"领券中心","scene":"公共","项目tab":"","属性tab":"",“name”:"","refid":"${this.refid}","gonggao":"公告"}"}`, 'coupon_tanchuang_click');
    },
    skip() {
      this.track('我的优惠券-弹窗跳转点击', `{"channel":"领券中心","scene":"公共","refid":"${this.refid}"}`, 'coupon_tanchuang_click');
      _multi_bridge.navigateTo({
        url: 'https://m.17u.cn/couponstore/index?wvc6=1&tcwvclogin',
      });
    },
    track(label, value, action, category) {
      console.log('track: ', label, value, action, category);
      _multi_bridge_ready(() => {
        _multi_bridge.trackData({
          pname: '我的优惠券',
          category: category || 'cvg2021_apppublic_mycouponpage',
          action: action,
          id: label,
          value: encodeURIComponent(value),
        });
      });
    },

    config() {
      _multi_bridge_ready(() => {
        if (this.$isTC || this.$isEL) {
          _tc_bridge_util.set_webview_info({
            param: {
              webview: {
                immersionSwitch: '1',
              },
            },
            callback: (data) => { },
          });

          // 导航栏
          _multi_bridge.invoke('_tc_bridge_bar.set_navbar', {
            param: {
              center: [{ value: '我的优惠券' }],
              right: [
                // {
                //   tagname: 'tag_click_coupon',
                //   icon: 'i_share_white',
                //   value: '券码',
                //   dataImage:
                //     'data:image/png;base64,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',
                // },
              ],
            },
            callback: (data) => {
              // 自定义逻辑
              this.popShow = true;
            },
          });
        }
      });
    },
    openNewUrl(url) {
      if (!url) return;
      if (url.indexOf('eltclient') > -1 || url.indexOf('tctclient') > -1) {
        window.location.href = url;
      } else {
        _tc_bridge_web.open_newurl({
          param: {
            tagname: 'tagback',
            openParams: `newWindow,hideBottom`,
            jumpUrl: url,
          },
          callback: (data) => { },
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.home {
  background: #f6f8fb;

  &-contain {
    padding-top: 93px;
    // padding-bottom: 80px;
    padding-bottom: calc(constant(safe-area-inset-bottom));
    padding-bottom: calc(env(safe-area-inset-bottom));

    .err-tips {
      margin-top: 15px;
      text-align: center;

      &-icon {
        height: 17px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ff7164;
        line-height: 17px;
      }

      &-text {
        height: 17px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 17px;
      }
    }

    .banner {
      position: relative;

      &-icon {
        width: 22px;
        height: 22px;
        right: 25px;
        top: 50%;
        transform: translateY(-50%);
        z-index: 2;
        position: absolute;
      }

      &-content {
        height: 40px;
        margin: 10px 15px 0 15px;
        background: #fff9f2;
        border-radius: 4px;
        overflow-y: hidden;
        overflow-x: scroll;
        display: flex;

        &-item {
          flex-shrink: 0;
          width: 100%;

          &-pic {
            object-fit: cover;
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    .redpackhome {
      width: 100%;
    }

    .home-loading {
      z-index: 1;
      position: absolute;
      height: 100%;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #f6f8fb;

      img {
        position: absolute;
        width: 40px;
        height: 40px;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 2;
      }
    }

    .no-result {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      // margin-bottom: 200px;

      img {
        width: 84px;
        height: 104px;
        margin-top: 126px;
      }

      span {
        margin-top: 28px;
        font-size: 15px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #666;
        line-height: 24px;
      }
    }
  }

  &-btn {
    position: fixed;
    bottom: 0;
    width: 374px;
    height: 75px;
    line-height: 75px;
    background: #fff;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.07);
    z-index: 888;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    text-align: center;
    padding-bottom: calc(constant(safe-area-inset-bottom) - 20px);
    padding-bottom: calc(env(safe-area-inset-bottom) - 20px);

    &-tip {
      position: absolute;
      top: 10px;
      left: 215px;
      padding: 0 5px;
      background-image: linear-gradient(270deg, #ff5634 0%, #ffa759 69%, #ffc747 99%);
      border-radius: 9px 9px 9px 0;
      height: 18px;
      font-family: PingFangSC-S0pxibold;
      font-weight: bold;
      font-size: 10px;
      color: #fff;
      line-height: 18px;
    }
  }
}
</style>
